import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreInitiativesExportPostAsyncSlice } from './post';

export const coreInitiativesExportReducers = combineReducers({
	post: coreInitiativesExportPostAsyncSlice.asyncReducers
});

export const coreInitiativesExportWatchers = combineAllWatchers([ coreInitiativesExportPostAsyncSlice.asyncWatchers ]);
